import ReactDom from 'react-dom';

import { Overlay, Container } from './DetailsDialog.styles';

import { DetailsDialogRaw } from './DetailsDialog.raw';

interface IDetailsDialog {
  open: boolean;
  onClose: () => void;
  taskId: string;
}

export const DetailsDialog = ({ open, onClose, taskId }: IDetailsDialog) => {
  const portalDiv = document.getElementById('portal');

  return open && portalDiv
    ? ReactDom.createPortal(
        <Overlay>
          <Container>
            <DetailsDialogRaw taskId={taskId} onClose={onClose} />
          </Container>
        </Overlay>,
        portalDiv,
      )
    : null;
};
